<template>
  <div>
    <ChengKuangClaim v-if="userInfo.businessGroup == '城矿'" />
    <WuMaoClaim v-else />
  </div>
</template>

<script>
  import ChengKuangClaim from './chengkuang/list.vue';
  import WuMaoClaim from './list.vue';
  export default {
    name: 'saleInvoiceList',
    components: { ChengKuangClaim, WuMaoClaim },
  };
</script>

<style lang="scss" scoped></style>
